export enum DataManagerPaginatorPosition {
  NONE = 'none',
  TOP = 'top',
  BOTTOM = 'bottom',
  BOTH = 'both'
}
